import type { Component } from 'vue';
import { isString } from 'lodash'

import ModalLayer from '../component/overlay/ModalLayer.vue'
import type { OverlayOptions, OverlayPlugin, OverlayResult } from '../plugin';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $modal: typeof modal
    }
}

export function modal(this: { $overlay: OverlayPlugin },
    component: Component,
    props?: Record<string, any>,
    optionsOrId?: OverlayOptions|string
): Promise<OverlayResult> {

    const $overlay: OverlayPlugin = this.$overlay;
    if(!$overlay){
        throw 'No overlay plugin available to show modal';
    }

    const resolvedOptions: OverlayOptions = isString(optionsOrId) ? { id: optionsOrId } : optionsOrId;

    const fullOptions: OverlayOptions = {
        ...resolvedOptions,
        blocking: true,
        shader: true,
        layer: ModalLayer
    };

    return $overlay.show(component, props, fullOptions);
}

export const modalMixin = {

    methods: {
        $modal: modal
    }
}

export default modalMixin;